import React, { Fragment } from 'react';
import { css, StyleSheet } from 'aphrodite';

import { BaseEntityPage } from '../common/components/BaseEntityPage';
import { Helper } from '../common/helpers/Helper';
import LayoutPreview from './LayoutPreview';
import { AppStyles, AppTheme } from '../styles/AppTheme';
import { LayoutCreationDialog } from './LayoutCreationDialog';
import { CampaignMediaDNDItems } from '../screens/admin/CampaignMediaDNDItems';
import { UiHelper } from '../common/helpers/UiHelper';
import { AppHelper } from '../helpers/AppHelper';
import { AppButton } from '../common/components/AppButton';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { DynamicFormDialog } from '../common/components/DynamicFormDialog';
import { TableComponent } from '../common/components/TableComponent';
import { AppUiHelper } from '../helpers/AppUiHelper';
import { Stats } from './Stats';
import Dialog from '@material-ui/core/Dialog';
import { Grid, Tooltip } from '@material-ui/core';
import { DisplayPreviewDialog } from './DisplayPreviewDialog';
import { DisplayWeblinkPreviewDialog } from './DisplayWeblinkPreviewDialog';
import { AppConfig } from '../AppConfig';
import { Toast } from './Toast';
import { assetsFormAddition } from '../data/data';
const { v4: uuidv4 } = require('uuid');
export class EditLayoutWithMedia extends BaseEntityPage {

  constructor(props, options) {
    super(props, options)
    this.pageKey = 'LayoutsItems'
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.layoutId = this.props.match.params.id

    this.noTableHead = true
    this.state = {
      ...this.state,
      items: [],
      itemsBySection: {},
      // currentWidth: window.innerWidth,
      // currentHeight: window.innerHeight,
      displayPreview: false,
      showCmsMediaEdit: false
    }

    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: Helper.getString('layouts'), to: this.baseRoute() + '/layouts' },
      { title: Helper.getString('media') },
    ]


    this.toFetch = [
      { method: 'GET', paths: ['layouts',this.layoutId], queryParams: { orgId: this.orgId, pb: 'fieldDef', resolveassets: true } },
      { method: 'GET', paths: ['miscs','assets'], queryParams: { orgId: this.orgId, pb: 'fieldDef', limit: 1000, state: 'LIVE', iType: '_ALL' } },
      { method: 'GET', paths: ['miscs', 'slsources']}
    ]

    this.tableHeadersMap = {
      Index: (current) => current.__index + 1
    }
    this.noAdd = true
    this.actionData = {}

    // DND
    this.sourceTableId = 'media-items'
    this.droppableTableId = 'campaign-items'
    this.maxVisibleInSectionSlide = 4
    this.allowAccessToRoles = ['SUPERUSER']
  }

  onFetchSuccess(results) {
    // Options
    const options = {
      fieldKey: 'state',
      keyToReplace: 'LIVE',
      replaceWithValue: 'ENABLED',
    }

    this.layout = results[0]
    this.mediaItems = results[1]
    this.slSourceItems = results[2]
    this.slSourceItems.items.forEach(item => item.id = item.contentId)
    this.cmdMediaFieldDef = results[2].fieldDef
    this.cmdMediaFieldDef.formType = 'edit'

    this.pageTitle = this.layout.title
    this.mediaItems.items = this.mediaItems.items.filter(item => item.state !== 'DISABLED' && item.iType !== 'ACCUWEATHER')
    this.mediaItems.fieldDef = AppHelper.changeFieldOptionLabel(this.mediaItems.fieldDef, options)
    // Push New dateTimeStr Fields
    AppHelper.addScheduleFieldsToAssetsFormField(assetsFormAddition, this.mediaItems.fieldDef)
    this.formDefinitionMedia = {
      ...this.mediaItems.fieldDef,
      formType: 'add'
    }
    /* Upload Configs STARTS */
    // -- START --
    this.formDefinitionMedia.steps[0].fields.map((x) => {
      if (x.condition && x.condition.value === 'IMAGE') {
        x.autoFillTitleKey = 'title'
      }
      if (x.condition && x.condition.value === 'VIDEO' && x.documentUpload) {
        x.autoFillField = 'durationSecs' // add generic
        x.autoFillVideoDuration = true
        x.autoFillTitleKey = 'title'
        x.maxVideoDuration = AppHelper.getMaxVideoDuration(this.options, this.org)
        x.maxWidthOrHeight = 1920
        x.fileSizeLimit = AppHelper.getMaxVideoFileSize(this.options, this.org)
        if ((this.options && this.options.pageForOrgType && this.options.pageForOrgType === 'PARTNER') && this.org && AppHelper.hasFeature(this.org, 'LARGEVIDEO')) {
          x.maxWidthOrHeight = 4096 // 4k max res
        }
        // eslint-disable-next-line camelcase
        this.formDefinitionMedia.steps[0].fields.find(i => i.key === x.autoFillField).v_condition = { key: 'iType', value: 'VIDEO', type: 'disable' }
        // Change in label for video START ----
        AppHelper.attachVideoValidationLabel({
          formDefinition: this.formDefinitionMedia,
          maxWidthOrHeight: x.maxWidthOrHeight,
          maxVideoDuration: x.maxVideoDuration,
          fileSizeLimit: x.fileSizeLimit
        })
        // END ----
      }
    })
    // -- End --
    if (AppConfig.FEATURES_OFF.includes('ASSET_WEBLINK')) {
      this.formDefinitionMedia.steps[0].fields.find(i => i.key === 'iType').options = this.formDefinitionMedia.steps[0].fields.find(i => i.key === 'iType').options.filter(x => x.key !== 'WEBLINK')
    }
    // Hiding ACCUWEATHER from dropdown since not relevant in layouts page
    this.formDefinitionMedia.steps[0].fields.find(i => i.key === 'iType').options = this.formDefinitionMedia.steps[0].fields.find(i => i.key === 'iType').options.filter(x => x.key !== 'ACCUWEATHER')
    /* Upload Configs ENDS */

    const items = this.state.itemsBySection
    this.layout.layoutjson.sections.map((x, i) => {
      items[i] = x.media && x.media.length > 0 ? x.media : []
    })
    // Set state
    this.setState({
      layout: this.layout,
      selectedIndex: 0,
      selectedItem: this.layout.layoutjson.sections[0] ? this.layout.layoutjson.sections[0] : null,
      itemsBySection: items,
      mediaItems: (this.layout && this.layout.layoutType === 'SL') ? this.slSourceItems.items : Helper.dictToArray(this.mediaItems.items),
      mediaModalAction: false,
      isDragEnabled: (!UiHelper.isUserHasRoles(this.allowAccessToRoles)) ? false : true,
      mediaFilterValue: '_ALL'
    },()=>{
      this.updateCounts()
    })

    // Generate_options_from_iTypes
    const mediaFormOptions = this.formDefinitionMedia.steps[0].fields.find(i => i.key === 'iType').options
    const newOptions = mediaFormOptions.map((option) => ({
      key: option.key,
      value: option.key
    })).concat([
      { key: '_ALL', value: 'ALL' },
    ])
    this.singlePickerFilter = newOptions || []
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onChangeSearchValue = (event) => {
    if (!event.target.value) {
      const setStateObj = { userInput: null }
      this.setState(setStateObj, this._handleSearchAction)
      return
    }
    this.setState({
      userInput : event.target.value && event.target.value.toLowerCase()
    })
  }

  _handleSearchAction = async (event) => {
    if (!this.state.userInput  && !this.state.mediaFilterValue) {
      return
    }
    this.setState({ inProcessSearch: true });
    const queryParams = {}
    if (this.state.userInput) {
      queryParams.query = this.state.userInput
    }
    queryParams.orgId = this.orgId;
    queryParams.state = 'LIVE'
    queryParams.pb = 'fieldDef'
    queryParams.iType = this.state.mediaFilterValue
    try {
      const response = await ApiHelper.callAwait({
        method: 'GET',
        endPoint: ApiHelper.makeUrlPath(['miscs', 'assets'], queryParams),
      })
      this.setState({
        filteredMediaItems: response.items,
        errMsg: null,
        inProcessSearch: false
      })
    } catch(err) {
      this.setState({
        message: Helper.getErrorMsg(err),
        showToast: true,
        severity: 'error',
        filteredMediaItems: [],
        inProcessSearch: false
      })
    }
  };

  // Slide Section
  handleOnChangeSectionSelection = (data) => {
    const selectedItem = data.item
    const newIndex = data.index
    this.setState({ selectedIndex: newIndex, selectedItem: selectedItem }, () => {
      const refKey = `sectionRef${newIndex}`
      // Check .current, not the ref object itself
      if (
        this[refKey] &&
        this[refKey].current &&
        this[refKey].current.scrollIntoView
      ) {
        this[refKey].current.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        })
      }
      this.updateCounts()
    })
  }

  updateCounts = () => {
    // Update cards
    this.setState({
      cards:[
        {
          title: Helper.getString('itemsCountText'),
          value: this._getTotalMediaOfAllSection() || '0',
          image: require('../assets/icons/stats/media.svg')
        },
        {
          title: Helper.getString('mediaDuration'),
          value: (this.state.layout && this.state.layout.layoutType === 'SL') ? this._getDurationForSLLayout() : AppHelper.formatDuration(this._getMaxDurationOfAllSection()),
          image: require('../assets/icons/stats/duration.svg')
        }
      ]
    })
  }

  handlePrev = () => {
    if (this.state.selectedIndex <= 0) {
      return
    }

    const newIndex = this.state.selectedIndex - 1
    const selectedItem = this.state.layout.layoutjson.sections[newIndex]
    this.setState({ selectedIndex: newIndex, selectedItem: selectedItem }, () => {
      const refKey = `sectionRef${newIndex}`
      if (this[refKey] && this[refKey].current && this[refKey].current.scrollIntoView) {
        this[refKey].current.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        })
      }
    })
  }

  handleNext = () => {
    const layoutItems = this.state.layout.layoutjson.sections || []
    if (this.state.selectedIndex >= layoutItems.length - 1) {
      return
    }

    const newIndex = this.state.selectedIndex + 1
    const selectedItem = this.state.layout.layoutjson.sections[newIndex]

    this.setState({ selectedIndex: newIndex, selectedItem: selectedItem }, () => {
      const refKey = `sectionRef${newIndex}`
      if (this[refKey] && this[refKey].current && this[refKey].current.scrollIntoView) {
        this[refKey].current.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        })
      }
    })
  }

  getSectionTabs() {
    const layoutItems = this.state.layout && this.state.layout.layoutjson && this.state.layout.layoutjson.sections ? this.state.layout.layoutjson.sections : []
    // If no items, nothing to render
    if (!layoutItems || layoutItems.length === 0) {
      return null;
    }

    return (
      <div className={css(Styles.sliderContainer)}>
        {/* Left Arrow */}
        {layoutItems && layoutItems.length > 3 && this.state.selectedIndex > 0  &&
          <button className={css(Styles.arrowButton, Styles.leftArrowButton)} onClick={this.handlePrev}>
            <span className='material-icons-outlined'>navigate_before</span>
          </button>
        }
        {/* Sections */}
        <div className={css(Styles.sectionsWrapper)}>
          {layoutItems.map((item, index) => {
            const isActive = index === this.state.selectedIndex
            const refKey = `sectionRef${index}`

            // Create and store a ref for this item
            this[refKey] = this[refKey] || React.createRef()

            return (
              <div
                key={item.id}
                ref={this[refKey]}
                onClick={() =>
                  this.handleOnChangeSectionSelection({ item, index })
                }
                className={css(
                  Styles.sectionItem,
                  isActive && Styles.sectionItemActive
                )}
              >
                {item.type === 'section' && `Section ${index + 1}`}
                {item.type === 'overlay' && `Overlay ${index + 1}`}
              </div>
            )
          })}
        </div>
        {/* Right Arrow */}
        {layoutItems && layoutItems.length > 3 && (this.state.selectedIndex < layoutItems.length - 1)  &&
          <button
            className={css( Styles.arrowButton, Styles.rightArrowButton)}
            onClick={this.handleNext}>
            <span className='material-icons-outlined'>navigate_next</span>
          </button>
        }
      </div>
    )
  }

  openModalForDelete(current) {
    const { itemsBySection, selectedIndex } = this.state;
    if (selectedIndex !== null && selectedIndex !== undefined && itemsBySection[selectedIndex]) {
      const updatedMediaItemsOfSelectedTab = itemsBySection[selectedIndex].filter(item => item.id !== current.id);
      const updatedItemsByTab = {
        ...itemsBySection,
        [selectedIndex]: updatedMediaItemsOfSelectedTab
      };
      this.setState({
        itemsBySection: updatedItemsByTab
      }, () => {
        this.updateCounts()
        console.log('Item with id', current.id, 'removed from tab index:', selectedIndex);
      });
    } else {
      console.log('Invalid tab index or no items found for this tab:', selectedIndex);
    }
  }

  onActions(current) {
    const actions = []
    if(current && current.iType === 'IMAGE' || current.iType === 'VIDEO' || current.iType === 'WEBLINK') {
      UiHelper.addActionButtonByRole(actions, this.imageVideoPreview(current), [])
    }
    if(current && current.iType === 'CMS') {
      UiHelper.addActionButtonByRole(actions, this.placementLabelEdit(current), [])
    }
    UiHelper.addActionButtonByRole(actions, UiHelper.buttonDelete(this, current), this.allowAccessToRoles)
    return actions
  }

  imageVideoPreview(current) {
    return (
      <Tooltip title='Preview' placement='top-start' key={current.id + 'Preview'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <img className={css(Styles.actionIconImage)} src={require('../assets/icons/eye.svg')} onClick={() => { this.setState({ preview: true, current }) }} />
        </span>
      </Tooltip>
    )
  }

  handleCmsMediaEdit = async (data) =>{
    const {formData, caller} = data
    const { itemsBySection, selectedIndex } = this.state;
    if (selectedIndex !== null && selectedIndex !== undefined && itemsBySection[selectedIndex]) {
      itemsBySection[selectedIndex].forEach(item => {
        item.placementLabel = formData.placementLabel
      });
      const updatedItemsByTab = {
        ...itemsBySection,
      };
      this.setState({
        itemsBySection: updatedItemsByTab,
        showCmsMediaEdit: false
      });
    } else {
      console.log('Invalid tab index or no items found for this tab:', selectedIndex);
    }
  }

  renderCMSMediaEdit() {
    if(!this.state.showCmsMediaEdit) return ''
    return (
      <DynamicFormDialog
        customSubmit={this.handleCmsMediaEdit}
        formDefinition={this.cmdMediaFieldDef}
        isOpen={this.state.showCmsMediaEdit}
        onClosed={() => this.setState({showCmsMediaEdit: false})}
      >
      </DynamicFormDialog>
    )
  }

  placementLabelEdit(current) {
    return (
      <Tooltip title='Placement Label' placement='top-start' key={current.id + 'placementLabel'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <img className={css(Styles.actionIconImage)} src={require('../assets/icons/edit-row-icon.svg')} onClick={() => {
            Helper.populateFormDefinitionValues(this.cmdMediaFieldDef, current)
            this.setState({ showCmsMediaEdit: true, current })
          }} />
        </span>
      </Tooltip>
    )
  }

  mediaPreview(current) {
    return (
      <Tooltip title='Preview' placement='top-start' key={current.assetsDetails.id + 'Preview'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <img className={css(Styles.actionIconImage)} src={require('../assets/icons/eye.svg')} onClick={() => { this.setState({ preview: true, current: current.assetsDetails }) }} />
        </span>
      </Tooltip>
    )
  }

  // DND

  // Handle Drag
  handleOnDragStart = (start, provided) => { }
  handleOnDragEnd = (result) => {
    // Extract the destination and source from the result object
    const { destination, source } = result;

    // Return early if there's no destination (dropped outside a droppable) or source (no drag start)
    if (!destination || !source) return;

    // Check if the item was dropped within the same table but in a different position
    if (
      destination.droppableId === this.droppableTableId &&
      destination.droppableId === source.droppableId &&
      destination.index !== source.index
    ) {
      // Ensure the item exists at the source index
      if (!this.state.itemsBySection[this.state.selectedIndex][source.index]) return;

      // Disable dragging during the update
      // this.setState({ isDragEnabled: false });

      // Create a new array of items and move the dragged item to the new position
      const updatedItems = Array.from(this.state.itemsBySection[this.state.selectedIndex]);
      const [movedItem] = updatedItems.splice(source.index, 1);
      // movedItem._loading = true; // Mark the item as loading
      updatedItems.splice(destination.index, 0, movedItem);

      // Update the state with the new order and trigger an update function
      this.setState({
        itemsBySection: {
          ...this.state.itemsBySection,
          [this.state.selectedIndex]: updatedItems
        }
      }, () => {
        // const newIds = this.state.items.map((x) => x.id);
        // this._updateOrderOfItems(newIds);
      });

      // Check if the item was moved from a different table (e.g., adding new media)
    } else if (
      destination.droppableId === this.droppableTableId &&
      source.droppableId === this.sourceTableId
    ) {
      // Ensure the media item exists at the source index
      const mediaItems = this.state.filteredMediaItems || this.state.mediaItems
      if (!mediaItems || mediaItems.length < (source.index + 1) || !mediaItems[source.index]) return

      // Disable dragging during the update
      // this.setState({ isDragEnabled: false });

      // Add the new media item to the list
      const media = this.state.filteredMediaItems && this.state.filteredMediaItems.length > 0 ? this.state.filteredMediaItems[source.index] : this.state.mediaItems[source.index];

      // Check if the current selected component is a overlay.
      // If overlay, don't allow to add video & Weblink
      if (this.state.selectedItem && this.state.selectedItem.type === 'overlay' && media.iType !== 'IMAGE' && media.iType !== 'TEXT' ) {
        this.setState({
          message: Helper.getString('overlayVideoNotAllowedMessage'),
          showToast: true,
          severity: 'error',
        })
        return
      }

      // Generate a new order of items including the new media
      // const existingIds = this.state.itemsBySection[this.state.selectedIndex].map((x) => x.id);
      // const newIds = this._insertAtIndex(existingIds, destination.index, '_NEW');
      // Check and how error if multiple section has video
      if (!this._isValidMediaForSection(media)) {
        this.setState({
          message: this._getErrForinValidMediaForSection(media),
          showToast: true,
          severity: 'error',
        })
        return
      }
      if (!this._isValidMediaSLLayout(media)) {
        this.setState({
          message: Helper.getString('oneSectionOneMedia'),
          showToast: true,
          severity: 'error',
        })
        return
      }
      // Prepare the parameters for adding and reordering the items
      const textParams = {}
      if(media.iType === 'TEXT') {
        textParams.text = media.text || null,
        textParams.speed = media.speed || null,
        textParams.direction = media.direction || null,
        textParams.foregroundColor = media.foregroundColor || null,
        textParams.backgroundColor = media.backgroundColor || null
      }
      const param = {
        iType: media.iType,
        mediaType: media.iType,
        state: media.state,
        durationSecs: media.durationSecs,
        orgId: media.orgId,
        id: uuidv4(), // auto generate one uuid
        title: media.title,
        contentId: media.id,
        contentName: media.contentName,
        content: media.iType === 'WEBLINK' ? media.contentName : media.content,
        // _neworders: newIds,
        ...textParams
      };

      if(this.state.layout && this.state.layout.layoutType === 'SL') {
        for(const key in param) {
          if(param[key] === undefined) delete param[key]
        }
        for(const item of this.slSourceItems.items) {
          if(item.iType === media.iType) {
            param.contentId = item.contentId
            param.orgId = this.orgId
            param.placementLabel = item.placementLabel
            param.title = item.title
          }
        }
      }

      // Create a new object, mainly for showing action, that media is being added
      const newObject = {
        ...param,
        __index: Math.floor(Math.random() * 99999999),
      };

      // Insert the new media object into the items array and update the state
      const items = Array.from(this.state.itemsBySection[this.state.selectedIndex])
      items.splice(destination.index, 0, newObject)
      this.setState({
        itemsBySection: {
          ...this.state.itemsBySection,
          [this.state.selectedIndex]: items
        }
      },()=>{
        this.updateCounts()
      });
    }
  }

  _getErrForinValidMediaForSection(media) {
    if(media.iType === 'VIDEO')
      return Helper.getString('videoPresent')
    if(media.iType === 'HDMI-IN')
      return Helper.getString('hdmiPresent')
    if(media.iType === 'PROG_AND_CMS')
      return Helper.getString('progCmsPresent')
  }

  _isValidMediaForSection(media) {
    if (media.iType === 'VIDEO') {
      const { itemsBySection, selectedIndex } = this.state
      for (const key in itemsBySection) {
        if (key !== selectedIndex.toString() && itemsBySection[key].some(item => item.iType === 'VIDEO')) {
          return false
        }
      }
    } else if (media.iType === 'HDMI-IN') {
      const { itemsBySection, selectedIndex } = this.state
      for (const key in itemsBySection) {
        if (key !== selectedIndex.toString() && itemsBySection[key].some(item => item.iType === 'HDMI-IN')) {
          return false
        }
      }
    } else if (media.iType === 'PROG_AND_CMS') {
      const { itemsBySection, selectedIndex } = this.state
      for (const key in itemsBySection) {
        if (key !== selectedIndex.toString() && itemsBySection[key].some(item => item.iType === 'PROG_AND_CMS')) {
          return false
        }
      }
    }
    return true
  }

  _isValidMediaSLLayout(media) {
    if(this.state.layout && this.state.layout.layoutType !== 'SL') return true
    const { itemsBySection, selectedIndex } = this.state
    if(itemsBySection && itemsBySection[selectedIndex].length > 0) return false
    return true
  }

  _insertAtIndex = (array, index, content) => {
    const updatedArray = [...array];
    updatedArray.splice(index, 0, content);
    return updatedArray;
  }

  _listThumbnail = (current) => {
    if (!current) return ''
    if (current.iType === 'VIDEO') {
      return AppUiHelper.renderVideoThumbnailCustomStyle(current, {}, { _IMAGEFIT: false })
    } else if (current.iType === 'WEBLINK') {
      return (<i alt={Helper.getString('assetImageAlt')} className={'material-icons-outlined ' + css(Styles.icons)} >http</i>)
    } else if (current.iType === 'TEXT') {
      return (<i alt={Helper.getString('assetTextAlt')} className={'material-icons-outlined ' + css(Styles.icons)} >text_snippet</i>)
    } else if (current.iType === 'HDMI-IN') {
      return (<i alt={Helper.getString('assetHdmiAlt')} className={'material-icons-outlined ' + css(Styles.icons)} >settings_input_hdmi</i>)
    } else if (current.iType === 'MEDIA') {
      return this.listThumbnail(this.item.__resolves.assetsById[current.contentName])
    } else {
      return (
        AppUiHelper.itemImage({ ...current, _IMAGEFIT: false, image: current.iType === 'IMAGE' ? current.content : undefined })
      )
    }
  }

  renderDropTable() {
    const tableHeadersMap = {
      // Index: (current) => current.__index + 1,
      grabber: (current) => {
        return (
          <div className={css(Styles.displayGrabber)}>
            <img className={css(Styles.grabberImage)} src={require('../assets/icons/grabber.svg')} />
          </div>
        )
      },
      Order: (current) => {
        return (
          <div className={css(Styles.displayMiddle)}>{current.order}</div>
        )
      },
      title: (current) => {
        return (
          <div className={css(Styles.thumbnailDetails)}>
            {this._listThumbnail(current)}
            <div>
              <div className={css(Styles.spanValue, Styles.title)}>{current.title}</div>
              <span className={css(Styles.spanValue)}>{
                current.iType === 'MEDIA' && this.item.__resolves && this.item.__resolves.assetsById[current.contentName]
                  ?
                  this.item.__resolves.assetsById[current.contentName].iType
                  :
                  current.iType
              }</span>
              {((current.assetsDetails && current.assetsDetails.durationSecs) || current.durationSecs) &&
                <Fragment>
                  <span> | </span>
                  <span className={css(Styles.spanValue)}>{(current.assetsDetails && current.assetsDetails.durationSecs) ? parseFloat(current.assetsDetails.durationSecs).toFixed(2) : parseFloat(current.durationSecs).toFixed(2)} Sec</span>
                </Fragment>
              }
            </div>
          </div>
        )
      },
      Status: (current) => {
        if(this.state.layout && this.state.layout.layoutType === 'SL') {
          return current.placementLabel ? AppUiHelper.placementContainer(current) : <span className={css(Styles.mediaDeleted)}>{Helper.getString('placementNotSet')}</span>
        }
        return (current.iType !== 'MEDIA' || (current.iType === 'MEDIA' && current.assetsDetails && current.assetsDetails.iType)) ? AppUiHelper.itemStatusContainer(current) : <span className={css(Styles.mediaDeleted)}>{Helper.getString('mediaDeleted')}</span>
      }
    }
    const tableHeaders = Object.keys(tableHeadersMap)

    return (
      <TableComponent
        tableHeaders={tableHeaders}
        noTableHead={true}
        onTableValue={this.onTableValue ? this.onTableValue.bind(this) : this.onTableValue}
        tableHeadersMap={tableHeadersMap}
        items={this.state.itemsBySection[this.state.selectedIndex]}
        // items={this.state.items}
        // setItems={this.setItems}
        headerActions={[]} //Multi checkbox
        onActions={this.onActions.bind(this)}
        onMenuItems={this.onMenuItems && this.onMenuItems.bind(this)}
        nextPage={this.state.nextPage}
        nextPageState={this.state.nextPageState}
        onNext={this.onNext.bind(this)}
        emptyText={this.emptyText}
        cellWidths={this.cellWidths}
        displayCheckBoxTable={this.displayCheckBoxTable || false}
        checkBoxActions={this.checkBoxActions.bind(this)}
        isDragEnabled={this.state.isDragEnabled}
        droppableTableId={this.droppableTableId}
      />
    )
  }

  _getTotalMediaOfAllSection() {
    if(!this.state.itemsBySection) return 0
    const totalCount = Object.values(this.state.itemsBySection).reduce((count, item) => {
      return Array.isArray(item) ? count + item.length : count
    }, 0)
    return totalCount
  }

  _getDurationForSLLayout() {
    if(this.state.layout.durationType === 'LIMITED') return  AppHelper.formatDuration(parseFloat(this.state.layout.durationSecs || 0) * 1000)
    if(this.state.layout.durationType === 'FOREVER') return 'Forever'
    return AppHelper.formatDuration(0)
  }

  _getMaxDurationOfAllSection() {
    const itemsBySection = this.state.itemsBySection;
    let maxDuration = 0;

    // Loop through each list in itemsBySection
    Object.keys(itemsBySection).forEach(key => {
      const list = itemsBySection[key];
      // Calculate the total duration of the current list
      const totalDuration = list.reduce((sum, item) => sum + parseFloat(item.durationSecs), 0);

      // Update maxDuration if the current list's total duration is greater
      if (totalDuration > maxDuration) {
        maxDuration = totalDuration;
      }
    });

    // Convert maxDuration (in seconds) to HH:MM:SS format
    // const hours = Math.floor(maxDuration / 3600);
    // const minutes = Math.floor((maxDuration % 3600) / 60);
    // const seconds = maxDuration % 60;

    // const formattedDuration = `${hours.toString().padStart(2, '0')}Hr ${minutes.toString().padStart(2, '0')}Min ${seconds.toString().padStart(2, '0')}Sec`;

    return maxDuration * 1000;
  }

  saveAndPreview = () => {
    this.layout.layoutjson.sections.map((e,i)=>{
      this.layout.layoutjson.sections[i].media = this.state.itemsBySection[i]
    })
    this.setState({ displayPreview: true, selectedLayout: this.layout })
  }

  _saveLayoutAndMedia = () => {
    this.layout.layoutjson.sections.map((e,i)=>{
      this.layout.layoutjson.sections[i].media = this.state.itemsBySection[i]
    })
    this.setState({ inProcess: true })
    // Save and refresh
    const saveOutputJson = {
      ...this.layout,
      mediaType:'LAYOUT'
    }
    const apiEndpoint = {
      method: 'put', paths: ['layouts', this.layoutId],
      jsonBody: { ...saveOutputJson }
    }
    ApiHelper.call(apiEndpoint, (err, result) => {
      this.setState({ inProcess: false })
      if (result && result.id) {
        this.fetchItems()
        return
      }
      if (err || !result.id) {
        // const errorMessage = Helper.getErrorMsg(err)
        this.setState({
          // errorMessage: errorMessage,
          message: Helper.getErrorMsg(err),
          showToast: true,
          severity: 'error',
        })
        return
      }
    })
  }

  singlePickerHandler(e) {
    const value = e.target.value
    this.setState({
      mediaFilterValue: value
    })
  }

  renderTable() {
    // alert()
    if (!this.onTableValue) {
      return ''
    }

    const maxWidth = 110
    const maxHeight = 75
    const landscapeSize = AppUiHelper.calculateRenderDimensions(this.state.layout, maxWidth, maxHeight)
    const portraitSize = AppUiHelper.calculateRenderDimensions(this.state.layout, maxWidth, maxHeight)
    return (
      <Grid container spacing={3} className={css(Styles.gridContainer)}>
        <Grid item key={'campaigns-item-table'} lg={7} xs={12} sm={6} md={7}>
          <div className={css(Styles.layoutAndMediaContainers, Styles.layoutMediaContainer)}>
            {/* Layout Infos */}
            <div className={css(Styles.infoBlock)}>
              <div className={css(Styles.layoutDetails)}>
                {/* Details */}
                <div className={css(Styles.layoutInfo)}>
                  { this.state.cards && <Stats lg={1} items={this.state.cards} statsBody={Styles.statsBody}></Stats> }
                </div>
                {/* Layout Thumbnail */}
                <div className={css(Styles.layoutThumbnailHolder)}>
                  <span style={{cursor: 'pointer'}}>
                    {this.state.layout.width < this.state.layout.height && <LayoutPreview renderDimensions={portraitSize} layoutJson={this.state.layout} selectedItem={this.state.selectedItem} onChangeSectionSelection={this.handleOnChangeSectionSelection} />}
                    {this.state.layout.width > this.state.layout.height && <LayoutPreview renderDimensions={landscapeSize} layoutJson={this.state.layout} selectedItem={this.state.selectedItem} onChangeSectionSelection={this.handleOnChangeSectionSelection} />}
                  </span>
                  <div>
                    <span className={'material-icons-outlined ' + css(Styles.editLayoutButton)} onClick={() => { this._editLayoutEditor() }}>edit</span>
                  </div>
                </div>
              </div>

              {/* Section Tabs */}
              <div>
                {this.getSectionTabs()}
              </div>
            </div>

            <div className={css(Styles.actionDndBlock)}>
              {/* Droppable area */}
              <div className={`${css(Styles.scrollTable)} scrollTable`}
                style={
                  this.state.itemsBySection[this.state.selectedIndex] && this.state.itemsBySection[this.state.selectedIndex].length < 4
                    ? { overflow: 'hidden' }
                    : { overflow: 'auto' }
                }>
                {/* <span style={{color: '#656565'}}>
                [ Drag & Drop Media Here ]
                </span> */}
                {this.renderDropTable()}
              </div>

              {/* Action Button */}
              <div className={css(Styles.bottomButtonBar)}>
                <div className={css(Styles.infoBottom)}>
                  {/* <span>Associated Displays (0)</span> */}
                </div>
                <div className={css(Styles.bottomBarActionSection)}>
                  <div className={css(Styles.showAndPreviewButton)}>
                    <span className={'material-icons-outlined ' + css(Styles.showAndPreviewIcon)} >visibility</span>
                    <span className={css(Styles.showAndPreviewText)} onClick={this.saveAndPreview} >{Helper.getString('saveAndPreview')}</span>
                  </div>
                  <div>
                    <AppButton
                      onClick={this._saveLayoutAndMedia}
                      inProcess={this.state.inProcess || false}
                      buttonStyle={Styles.saveButton}
                      buttonText={Helper.getString('save')}
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </Grid>
        {/* Media List DND */}
        <Grid item key={'campaigns-media-table'} lg={5} xs={12} sm={6} md={5}>
          <CampaignMediaDNDItems
            isDropDisabled={true}
            draggingItem={this.state.draggingItem || null}
            droppableTableId={this.sourceTableId}
            isDragEnabled={this.state.isDragEnabled}
            mediaItems={this.state.filteredMediaItems || this.state.mediaItems || []}
            mediaUploadHandle={!UiHelper.isUserHasRoles(this.allowAccessToRoles) ? null : this._showMediaAddModal}
            handleSearchAction={this._handleSearchAction}
            onChangeSearchValue={this.onChangeSearchValue}
            query={this.state.userInput}
            inProcessSearch = {this.state.inProcessSearch}
            layout={this.state.layout || {}}
            handleAddButton={!UiHelper.isUserHasRoles(this.allowAccessToRoles) ? null : this._addMediaToTop}
            singlePickerOptions={this.singlePickerFilter || []}
            singlePickerHandler={this.singlePickerHandler.bind(this)}
            singlePickerDefaultValue={this.state.mediaFilterValue}
          />
        </Grid>
      </Grid>
    )
  }

  _editLayoutEditor = () => {
    this.layout.layoutjson.sections.map((e,i)=>{
      this.layout.layoutjson.sections[i].media = this.state.itemsBySection[i]
    })
    this.setState({ displayLayoutEditor: true })
  }

  _showMediaAddModal = () => {
    Helper.deleteFormDefinitionValues(this.formDefinitionMedia)
    this.setState({ mediaModalAction: true })
  }

  _hideMediaAddModal = () => {
    this.setState({ mediaModalAction: false })
  }

  _addMediaToTop = (props) => {
    if (!this.state.isDragEnabled) return;
    const params = {
      source: {
        index: props.index,
        droppableId: this.sourceTableId
      },
      destination: {
        droppableId: this.droppableTableId,
        index: 0
      },
    }
    this.handleOnDragEnd(params)
  }

  _customMediaUploadHandle = async (options) => {
    const { formData, caller, formType } = options
    const maxVideoDuration = AppHelper.getMaxVideoDuration(this.options, this.org)
    if (formData.iType === 'VIDEO' && Math.round(formData.durationSecs) > maxVideoDuration) {
      let errorMessage = Helper.getString('maxDurationVideo')
      errorMessage = errorMessage.replace('%second%', maxVideoDuration)
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: errorMessage,
        message: errorMessage,
        success: false,
        inProcess: false
      })
      return
    }
    if (formData.iType === 'IMAGE' && (formData.durationSecs > 15 || formData.durationSecs < 5) && this.orgId !== 'PRODUCT') {
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: Helper.getString('maxDurationImage'),
        message: Helper.getString('maxDurationImage'),
        success: false,
        inProcess: false
      })
      return
    }
    formData.durationSecs = parseInt(formData.durationSecs)
    formData.orgId = this.orgId
    const apiOptions = {
      method: 'POST',
      paths: ['assets', this.orgId],
      jsonBody: { ...formData }
    }

    try {
      const response = await ApiHelper.callAwait(apiOptions)
      this.setState({ mediaFilterValue: '_ALL', userInput: '' }, () => {
        this._refreshMediaList()
      })
    } catch (err) {
      caller.setState({
        inProcess: false,
        message: Helper.getErrorMsg(err),
        success: false,
      })
    }
  }

  _refreshMediaList = async () => {
    try {
      this.mediaItems = await ApiHelper.callAwait(this.toFetch[1])
      this.mediaItems.items = this.mediaItems.items.filter(item => item.state !== 'DISABLED' && item.iType !== 'ACCUWEATHER')
      const mediaItems_ = Helper.dictToArray(this.mediaItems.items)
      this.setState({
        mediaModalAction: false,
        mediaItems: mediaItems_,
        isDragEnabled: true,
        filteredMediaItems: null
      })
    } catch (err) {
      this.setState({
        mediaModalAction: false,
        inProcess: false,
        message: Helper.getErrorMsg(err),
        showToast: true,
        severity: 'error',
        isDragEnabled: true
      })
    }
  }

  getToast() {
    return (
      <Toast open={this.state.showToast}
        severity={this.state.severity}
        message={this.state.message}
        handleClose={() => this.setState({ showToast: false })}
      />
    )
  }

  _handleEditSuccessCallBack = () => {
    this.setState({ displayLayoutEditor: false })
    this.fetchItems()
  }

  renderAboveTable() {
    const scaleFactor = 1.4
    const scaleFactorPortrait = 2.2
    const { width, height } = this.state.layout;
    const isPortrait = width < height;

    const previewDimension = isPortrait ? {
      width: window.innerHeight / scaleFactorPortrait,
      height: window.innerWidth / scaleFactorPortrait,
    } : {
      width: window.innerWidth / scaleFactor,
      height: window.innerHeight / scaleFactor,
    }

    return (
      <Fragment>
        {this.getToast()}
        { (this.state.preview || this.state.current) && (this.state.current.iType === 'IMAGE' || this.state.current.iType === 'VIDEO') &&
          <DisplayPreviewDialog
            title={this.state.current.title}
            isOpen={this.state.preview ? true : false}
            adLink={this.state.current.content}
            onClosed={() => this.setState({ preview: undefined })}
          />
        }
        { (this.state.preview || this.state.current) && this.state.current.iType === 'WEBLINK' &&
          <DisplayWeblinkPreviewDialog
            title={this.state.current.title}
            isOpen={this.state.preview ? true : false}
            adLink={this.state.current.contentName}
            onClosed={() => this.setState({ preview: undefined })}
          />
        }

        {this.renderCMSMediaEdit()}

        {/* Fullscreen Display Preview */}
        {this.state.displayPreview && (
          // <div className={css(Styles.fullScreenDialog)}>
          //   {/* Close button */}
          //   <span className={css(Styles.closeButton)} onClick={() => this.setState({ displayPreview: false })}>
          //     <span className='material-icons-outlined'>cancel</span>
          //   </span>

          //   {/* Full-screen layout preview */}
          //   <LayoutPreview displayMedia={true} renderDimensions={{ width: this.state.currentWidth, height: this.state.currentHeight }} layoutJson={this.layout}  />
          // </div>
          <Dialog
            open={this.state.displayPreview}
            aria-labelledby={this.state.templateSelected ? Helper.getString('templateSetting') : Helper.getString('newLayout')}
            fullWidth={false}
            maxWidth='lg'
            classes={{
              root: css(Styles.root),
              paper: css(Styles.paper),
            }}
          >
            <div className={css(Styles.modalContent)} style={{ width: previewDimension.width, height: previewDimension.height }}>
              <span className={css(Styles.closeButton)} onClick={() => this.setState({ displayPreview: false })}>
                {UiHelper.renderImg({key:'dialogCloseIcon'})}
              </span>
              <LayoutPreview displayMedia={true} renderDimensions={{ width: previewDimension.width, height: previewDimension.height }} layoutJson={this.layout}  />
            </div>
          </Dialog>
        )}

        {/* Media Upload */}
        {this.state.mediaModalAction &&
          <DynamicFormDialog
            customSubmit={this._customMediaUploadHandle}
            formDefinition={this.formDefinitionMedia}
            isOpen={this.state.mediaModalAction || false}
            onClosed={this._hideMediaAddModal}
            uploadLocation={this.orgId}
          ></DynamicFormDialog>
        }


        {/* Edit Modal Layout */}
        {this.state.displayLayoutEditor && <LayoutCreationDialog
          successCallback={this._handleEditSuccessCallBack}
          editMode={true}
          layoutId={this.layoutId}
          layoutJson={this.state.layout}
          isOpen={this.state.displayLayoutEditor ? true : false}
          onClosed={() => this.setState({ displayLayoutEditor: false })} />}

      </Fragment>
    )
  }

}

const Styles = StyleSheet.create({
  statsBody:{
    padding: '0 4px',
    minWidth: 174
  },
  scrollTable: {
    height: window.innerHeight - 365,
    // overflow: 'auto',
    marginTop: 0,
    marginBottom: 15,
    borderRadius: 16,
  },
  mainContainer: {
    width: '100%',
    display: 'flex',
    gap: 10,
  },
  layoutAndMediaContainers: {
    flex: 1,
    borderRadius: 12,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flexWrap: 'nowrap'
  },
  actionDndBlock: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  dropArea: {
    // display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'space-evenly',
    // height: '100%'
  },
  infoBlock: {
    background: '#fff',
    borderRadius: 12
  },
  layoutMediaContainer: {
    flex: 2
  },
  allMediaList: {
    width: 400
  },
  layoutDetails: {
    display: 'flex',
    flexDirection: 'row',
    padding: 10,
    borderBottom: 'solid 1px #e6e5e5',
    justifyContent: 'space-between'
  },
  layoutThumbnailHolder: {
    borderRadius: 12,
    display: 'flex'
  },
  editLayoutButton: {
    margin: '4px 0px 0px 6px',
    color: AppTheme.primaryColor,
    cursor: 'pointer',
  },
  layoutInfo: {
    display: 'flex !important',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '4px 8px !important',
    fontSize: '14px !important',
    gap: '6px'
  },
  // Slide Section --- Start ----
  sliderContainer: {
    // display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    // background: '#f5f5f5',
    padding: '2px 0px',
    position: 'relative'
  },
  arrowButton: {
    background: '#fff',
    border: 'none',
    color: '#555',
    cursor: 'pointer',
    position: 'absolute',
    top: 4
  },
  leftArrowButton: {
    left: 0
  },
  rightArrowButton: {
    right: 0
  },
  arrowDisabled: {
    color: '#ccc',
    cursor: 'default',
  },
  sectionsWrapper: {
    maxWidth: 600,
    paddingLeft: 15,
    display: 'flex',
    overflowX: 'hidden',
    '::-webkit-scrollbar': {
      display: 'none'
    },
    '-ms-overflow-style': 'none',
    'scrollbar-width': 'none'
  },
  sectionItem: {
    fontSize: 14,
    color: '#9e9e9e', // gray
    cursor: 'pointer',
    borderBottom: '2px solid transparent',
    flex: 1,
    height: 24,
    paddingTop: 6,
    textAlign: 'center',
    minWidth: 150
  },
  sectionItemActive: {
    color: AppTheme.primaryColor,
    borderBottom: '2px solid ' + AppTheme.primaryColor,
  },
  // Slide section ---- End ---
  bottomButtonBar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '0px 16px 18px',
    alignItems: 'center',
    // marginTop: '26px',
    background: 'rgb(245 245 245)'
  },
  infoBottom: {
    fontSize: 14,
    color: AppTheme.primaryColor,
    flex: 1
  },
  bottomBarActionSection: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end'
  },
  showAndPreviewButton: {
    display: 'flex',
    alignItems: 'center',
    color: AppTheme.primaryColor,
    margin: '0px 12px',
    cursor: 'pointer'
  },
  showAndPreviewIcon: {
    color: AppTheme.primaryColor,
    fontSize: 16,
    margin: '0px 4px'
  },
  showAndPreviewText: {
    fontSize: 14
  },
  saveButton: {
    padding: 0,
    minWidth: 70,
    height: 40
  },
  displayGrabber: {
    paddingTop: 6
  },
  displayMiddle: {
    // paddingTop:10
  },
  thumbnailDetails: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  title: {
    fontSize: 16,
    color: '#121212',
    maxWidth: '150px',
    textAlignLast: 'revert-layer',
    whiteSpace: 'nowrap !important',
    overflow: 'hidden !important',
    textOverflow: 'ellipsis !important'
  },
  spanValue: {
    fontSize: 12
  },
  img: {
    height: 30
  },
  icons: {
    fontSize: 30,
    color: '#fff',
    marginRight: 12,
    background: 'rgb(228, 228, 228)',
    borderRadius: 8,
    width: 40,
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  mediaDeleted: {
    color: '#ff0d0d'
  },
  gridContainer: {
    marginBottom: 0
  },
  // Full-Screen Modal
  fullScreenDialog: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    // backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    cursor: 'pointer',
    zIndex: 10000,
    background: '#fff',
    display: 'flex',
    borderRadius: '50%',
    padding: 2
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: AppTheme.borderRadius
  },
})


// WEBPACK FOOTER //
// ./src/components/EditLayoutWithMedia.js